import { Button, Card, Col, Layout, PageHeader, Row, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router";

export const Dash: React.FC<{}> = () => {
  const navigate = useNavigate();

  const cards = [
    { title: "Size Groups", resource: "size_groups" },
    { title: "Sizes", resource: "sizes" },
    { title: "Compositions Groups", resource: "composition_groups" },
    { title: "Compositions", resource: "compositions" },
    { title: "Color Groups", resource: "color_groups" },
    { title: "Colors", resource: "colors" },
    { title: "Kind Groups", resource: "kind_groups" },
    { title: "Kinds", resource: "kinds" },
    { title: "Fittings", resource: "fittings" },
    { title: "Price Lists", resource: "price_lists" },
  ];

  return (
    <Layout className="content">
      <PageHeader ghost={true} title="Attributes" />
      <Layout.Content className="content">
        <Row gutter={[24, 24]}>
          {cards.map((card: any, j: any) => (
            <Col span={12} key={j}>
              <Card
                title={
                  <Typography.Title level={5} type="secondary">
                    {card.title}
                  </Typography.Title>
                }
                bodyStyle={{ display: "none" }}
                extra={
                  <Button type="primary" ghost onClick={() => navigate(card.resource)}>
                    Go to list
                  </Button>
                }
              />
            </Col>
          ))}
        </Row>
      </Layout.Content>
    </Layout>
  );
};
